'use client';
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import classnames from 'classnames';
import { nanoid } from 'nanoid';
import { Button, Label, TextInput, } from '../../index.js';
export const InlineForm = (_a) => {
    var { action, buttonText, className, id, label, labelAfter, method = 'post', placeholder, iconPosition, iconName, hideText, onChange, onSubmit, dense } = _a, other = __rest(_a, ["action", "buttonText", "className", "id", "label", "labelAfter", "method", "placeholder", "iconPosition", "iconName", "hideText", "onChange", "onSubmit", "dense"]);
    const componentClassName = classnames('sparky-c-inline-form', className, {});
    const [idVar, setId] = React.useState();
    React.useEffect(() => {
        setId(id || nanoid());
    }, [id]);
    function handleOnChange(e) {
        if (onChange) {
            onChange(e);
        }
    }
    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(e.currentTarget.elements.inlineFormInput.value);
    };
    return (_jsxs("form", Object.assign({ className: componentClassName, method: method, action: action, onSubmit: handleSubmit }, other, { children: [_jsx(Label, { htmlFor: idVar, labelAfter: labelAfter, className: "sparky-c-inline-form__label sparky-u-is-vishidden", text: label }), _jsx(TextInput, { id: idVar, className: "sparky-c-inline-form__input", float: false, dense: dense, placeholder: placeholder, name: "inlineFormInput", onChange: (e) => handleOnChange(e) }), _jsx(Button, { className: "sparky-c-inline-form__button", variant: "primary", text: buttonText, iconPosition: iconPosition, iconName: iconName, size: "lg", hideText: hideText, type: "submit" })] })));
};
//# sourceMappingURL=InlineForm.js.map